export default __webpack_public_path__ + "media/shalana.b9cb915f.jpg";